import routes from './publicSeoRoutes.js';
export const { DIRECTORY_QUERY_KEYS, directoryQueryPlan, normalizePublicUrl, publicDataPlan } = routes;
